import { t } from 'i18next';
import { Map } from 'ol';

import { isDefined } from '../../../utils/variables';
import { publish, SubscriptionTopic } from '../../../viewer/messaging/pubsub';
import { WmsState } from '../../../viewer/wms-state';

/**
 * Gets the attributions of the map's layers for what it shows, as HTML.
 */
export function getWmsAttributions(olMap: Map): string[] {
  const viewState = olMap.getView().getState();
  const extent = olMap.getView().calculateExtent(olMap.getSize());

  return olMap
    .getAllLayers()
    .flatMap((x) => x.getSource()?.getAttributions())
    .filter(isDefined)
    .flatMap((getAttributions) => {
      const attributions = getAttributions({ viewState, extent });
      return Array.isArray(attributions) ? attributions : [attributions];
    });
}

/**
 * Extracts the attributions for all the added layers and publishes it with PubSub.
 */
export function updateWmsAttributions(olMap: Map | null) {
  try {
    if (!isDefined(olMap)) {
      WmsState.instance.attributions = [];
      publish(SubscriptionTopic.WmsAttributionsChanged, []);
      return;
    }

    const attributions = getWmsAttributions(olMap);

    WmsState.instance.attributions = attributions;
    publish(SubscriptionTopic.WmsAttributionsChanged, attributions);
  } catch {
    publish(SubscriptionTopic.ToastrMessage, {
      message: t('wms.tool.failedToFetchAttributions', { ns: 'skyview' }),
      type: 'error',
    });
  }
}
